export const paths = ['/units-of-measure'];
